import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";

export function QueryParamsManager() {
    const [queryParams, setQueryParams] = useSearchParams();

    const isFirstRender = useRef(true);

    useEffect(() => {
        setQueryParams({
            tab: "discounts"
        }, {
            replace: isFirstRender.current
        })

        isFirstRender.current = false;
    }, []);

    return <></>
}